import { requestPost } from '../../common/request';

export async function uploadPic(query: any) {
  // 图片上传
  return await requestPost('/file/uploadFile', query);
}
